export interface IBulkResolveDto {
    ids: string[];
    resolvedAt: string;
    resolvedBy: string;
}
